import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { FetchUsersByID } from '../Common/Services/UserService';
import FailureAlert from '../Common/Failure';
import Axiosfetch from '../Common/Axiosfetch';
import baseURL from '../Common/Config';
import BusinessCard from '../../Images/BusinessCard.png';
import WelcomeIcon from '../../Images/MFILogo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faMapMarkerAlt, faEnvelope, faPhoneVolume,
    faDownload, faShareAlt, faUser, faGlobe
} from '@fortawesome/free-solid-svg-icons';
import whatsapp from '../../Images/whatsapp.png';

const EBusinessCard = () => {

    var { id } = useParams();
    const [SelectedUsers, setSelectedUsers] = useState({});
    const [LogoImage, setLogoImage] = useState(null);
    const [shareNumber, setshareNumber] = useState("");
    const [PaymentImage, setPaymentImage] = useState(null);
    const [SelectedUPI, setSelectedUPI] = useState("");
    const [NoData, setNoData] = useState(false);


    useEffect(() => {
        FetchUserData(id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const FetchUserData = (userid) => {
        if (id !== undefined && id !== null && id !== "") {
            FetchUsersByID({ _id: userid }, UserSuccess, Failure);
        }
    };

    const TextChange = (e) => {
        if (!isNaN(e.target.value) && e.target.value.length <= 10) {
            setshareNumber(e.target.value);
        }
    }

    const UserSuccess = (data) => {
        if (data.length > 0) {
            setSelectedUsers(data[0]);
            setNoData(false);
            if (data[0].Organization && data[0].Organization.length > 0 && data[0].Organization[0].Logo !== "") {
                if (LogoImage === null) {
                    Axiosfetch(baseURL + "GetOrganizationLogo", "POST", { fileName: data[0].Organization[0].Logo }, LogoSuccess, Failure);
                }

                if (data[0].Organization[0].PaymentLogo !== null && data[0].Organization[0].PaymentLogo !== undefined
                    && data[0].Organization[0].PaymentLogo !== "") {
                    setSelectedUPI(data[0].Organization[0].UPIID);
                    if (PaymentImage === null) {
                        FetchLogo(data[0].Organization[0].PaymentLogo);
                    }
                }
            }
        }
        else {
            setSelectedUsers({});
            setNoData(true);
        }
    };

    const LogoSuccess = (data) => {
        if (data.success) {
            setLogoImage(data.fileData);


        }
        else {
            setLogoImage(null);
        }
    };

    const FetchLogo = (file) => {
        Axiosfetch(baseURL + "GetPaymentLogo", "POST", { fileName: file }, PaymentSuccess, Failure);
    };

    const PaymentSuccess = (data) => {
        if (data.success) {
            setPaymentImage(data.fileData);

        }
    };

    const onTextChange = (e) => {

    };

    const onWebSiteClick = (website) => {
        if (website !== "") {
            window.open((website.indexOf("http") === -1 ? "http://" : "") + website);
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        <div style={{ backgroundColor: "#d0effe", width: "100%" }}>
            {SelectedUsers._id !== null && SelectedUsers._id !== undefined && (<div className="business-card-footer">
                <ul>
                    <li>
                        <a className="footer-link" href="#home">
                            <div className="footer-text">Home</div>
                        </a>
                    </li>
                    {SelectedUsers && SelectedUsers.Organization && SelectedUsers.Organization.length > 0 &&
                        SelectedUsers.Organization[0].AboutInfo && SelectedUsers.Organization[0].AboutInfo.length > 0 && (<li>
                            <a className="footer-link" href="#about">
                                <div className="footer-text">About</div>
                            </a>
                        </li>)}
                    {SelectedUsers && SelectedUsers.Organization && SelectedUsers.Organization.length > 0 &&
                        PaymentImage !== null && (<li>
                            <a className="footer-link" href="#payment">
                                <div className="footer-text">Payment</div>
                            </a>
                        </li>)}

                    {SelectedUsers && SelectedUsers.Organization && SelectedUsers.Organization.length > 0 &&
                        SelectedUsers.Organization[0].BCardImages && SelectedUsers.Organization[0].BCardImages.length > 0 && (<li>
                            <a className="footer-link" href="#bImages">
                                <div className="footer-text">Services</div>
                            </a>
                        </li>)}
                    <li>
                        <a className="footer-link" href="#enquiry">
                            <div className="footer-text">Enquiry</div>
                        </a>
                    </li>
                </ul>
            </div>)}

            {SelectedUsers._id !== null && SelectedUsers._id !== undefined && (<div className="container-fluid" style={{ padding: "10px" }}>
                <div id="home" className="row business-card-width" style={{ backgroundImage: ('url(' + BusinessCard + ')') }}>
                    <div className="align-center" style={{ width: "100%", fontSize: "26px" }}>
                        E-Business Card</div>
                    {LogoImage !== null && (<div className="align-center" style={{ width: "100%" }}>
                        <div className="company-logo" style={{ backgroundImage: ('url(' + LogoImage + ')') }}></div>
                    </div>)}
                    <div className="businness-card-content" style={{ color: "#0056b3" }}>

                        <h3 style={{ textAlign: "center" }}>{SelectedUsers.Organization && SelectedUsers.Organization.length > 0 && (
                            SelectedUsers.Organization[0].Name)}</h3>

                        <div className="business-card-action">
                            <a className="bcard-btn hover-style" href={`tel:+91${SelectedUsers.Organization && SelectedUsers.Organization.length > 0 &&
                                SelectedUsers.Organization[0].Contact}`}>
                                <h4 className="responsive-icon"><FontAwesomeIcon icon={faPhoneVolume}></FontAwesomeIcon></h4>
                                <span className="responsive-text">Call</span></a>
                            <a className="bcard-btn hover-style" href={`mailto:${SelectedUsers && SelectedUsers.EmailID}`}>
                                <h4 className="responsive-icon"><FontAwesomeIcon icon={faEnvelope}></FontAwesomeIcon></h4>
                                <span className="responsive-text">Mail</span></a>
                            <a className="bcard-btn hover-style" rel="noopener noreferrer" target="_blank" href={`https://wa.me/+91${SelectedUsers.Organization && SelectedUsers.Organization.length > 0 &&
                                SelectedUsers.Organization[0].Contact}?text=E-Business card : *${(SelectedUsers.Organization && SelectedUsers.Organization.length > 0) &&
                                SelectedUsers.Organization[0].Name}* , link : http://${window.location.hostname}/EBusinessCard/${id}`}>
                                <div style={{ padding: "0 8px" }}>
                                    <img alt="Logo" className="responsive-icon" src={whatsapp} width="30px" height="30px"></img></div>
                                <span className="responsive-text">Whatsapp</span></a>
                            <a href="https://g.page/Movers-Federation-of-India?share" rel="noopener noreferrer" target="_blank" className="bcard-btn hover-style">
                                <h4 className="responsive-icon"><FontAwesomeIcon icon={faMapMarkerAlt}></FontAwesomeIcon></h4>
                                <span className="responsive-text">Direction</span></a>

                        </div>
                        <table style={{ width: "100%" }}>
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="bcard-text-style" style={{ display: "flex" }}>
                                            <h4 style={{ color: "#364ed7", paddingRight: "15px" }}><FontAwesomeIcon icon={faUser}></FontAwesomeIcon></h4>
                                            <h4 className="innerH4">{SelectedUsers.FirstName + " " + SelectedUsers.LastName}</h4></div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="bcard-text-style" style={{ display: "flex" }}>
                                            <h4 style={{ color: "#364ed7", paddingRight: "15px" }}><FontAwesomeIcon icon={faMapMarkerAlt}></FontAwesomeIcon></h4>
                                            <h4 className="innerH4">{SelectedUsers.Organization && SelectedUsers.Organization.length > 0 && (
                                                `${SelectedUsers.Organization[0].AddressLine1} ${SelectedUsers.Organization[0].AddressLine2}, 
                            ${SelectedUsers.Organization[0].City}, ${SelectedUsers.Organization[0].State}, 
                            ${SelectedUsers.Organization[0].PostalCode}, ${SelectedUsers.Organization[0].Country}`
                                            )}</h4></div>
                                    </td>
                                </tr>
                                <tr>
                                    <td><div className="bcard-text-style" style={{ display: "flex" }}>
                                        <h4><FontAwesomeIcon icon={faEnvelope}></FontAwesomeIcon></h4>
                                        <h4 className="innerH4">{SelectedUsers.EmailID}</h4></div></td>
                                </tr>
                                <tr>
                                    <td><div className="bcard-text-style" style={{ display: "flex" }}>
                                        <h4><FontAwesomeIcon icon={faGlobe}></FontAwesomeIcon></h4>
                                        <h4 onClick={() => onWebSiteClick((SelectedUsers.Organization && SelectedUsers.Organization.length > 0) ?
                                            SelectedUsers.Organization[0].Website : "")} className="innerH4 cursor hover-style">{SelectedUsers.Organization && SelectedUsers.Organization.length > 0 &&
                                                SelectedUsers.Organization[0].Website}</h4></div></td>
                                </tr>
                                <tr>
                                    <td><div className="bcard-text-style" style={{ display: "flex" }}>
                                        <h4><FontAwesomeIcon icon={faPhoneVolume}></FontAwesomeIcon></h4>
                                        <h4 className="innerH4">{SelectedUsers.Organization && SelectedUsers.Organization.length > 0 &&
                                            SelectedUsers.Organization[0].Contact}
                                            {SelectedUsers.Organization && SelectedUsers.Organization.length > 0 &&
                                                SelectedUsers.Organization[0].AlternateContact !== 0 &&
                                                (` / ${SelectedUsers.Organization[0].AlternateContact}`)}</h4>

                                        <div className="bussiness-card-phonebook hover-style" title="Add Contact">
                                            <a href={`data:text/vcard;charset=UTF-8,BEGIN:VCARD VERSION:3.0 FN:${(SelectedUsers.Organization && SelectedUsers.Organization.length > 0) &&
                                                SelectedUsers.Organization[0].Name} TITLE:MFI EMAIL;TYPE=internet,pref:${SelectedUsers && SelectedUsers.EmailID} TEL;TYPE=work,voice:+91${SelectedUsers.Organization && SelectedUsers.Organization.length > 0 &&
                                                SelectedUsers.Organization[0].Contact} END:VCARD`} download="contact.vcf">
                                                <span>
                                                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="bcard-text-style" style={{ display: "flex" }}>
                                            {/* <img alt="Logo" style={{marginTop:"8px"}} src={whatsapp} width="25px" height="25px"></img> */}
                                            <span style={{ fontSize: "20px", padding: "0 10px" }}>+91
                                                <input placeholder="Whatsapp Number" value={shareNumber} onChange={TextChange} className="textbox-style" type="text"></input>
                                            </span>
                                            <a rel="noopener noreferrer" target="_blank" href={`https://wa.me/+91${shareNumber}?text=E-Business card : *${(SelectedUsers.Organization && SelectedUsers.Organization.length > 0) &&
                                                SelectedUsers.Organization[0].Name}* , link : http://${window.location.hostname}/EBusinessCard/${id}`}
                                                className="cursor hover-style" style={{ fontSize: "28px" }}>
                                                <span title="Whatsapp Business card Share" style={{ display: (shareNumber !== "" && !isNaN(shareNumber) && shareNumber.length === 10 ? "block" : "none") }}><FontAwesomeIcon icon={faShareAlt}></FontAwesomeIcon></span>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                {SelectedUsers.Organization && SelectedUsers.Organization.length > 0 &&
                    SelectedUsers.Organization[0].AboutInfo && SelectedUsers.Organization[0].AboutInfo.length > 0 && (
                        <div id="about" className="row business-card-width" style={{ backgroundImage: ('url(' + BusinessCard + ')'), marginTop: "20px" }}>
                            {SelectedUsers.Organization[0].AboutInfo.map((about, index) => (
                                <div style={{ paddingTop: "10px", width: "100%" }} key={index}>
                                    <div className="about-header">
                                        <h3>{about.Heading} :</h3></div>
                                    <div className="about-content">
                                        <h4>{about.Content}</h4></div>
                                </div>
                            ))}
                        </div>)}
                {SelectedUsers.Organization && SelectedUsers.Organization.length > 0 &&
                    PaymentImage !== null && (
                        <div id="payment" className="row business-card-width" style={{ backgroundImage: ('url(' + BusinessCard + ')'), marginTop: "20px" }}>
                            <div style={{ width: "100%", textAlign: "center", }}>
                                <div className="align-center" style={{ width: "100%" }}><h3><u>Payment Info</u></h3></div>
                                <div><img className="payment-responsive" width="350" height="350" alt="Payment Code" src={PaymentImage}></img></div>
                                <div><h4>UPI : {SelectedUPI}</h4></div>
                            </div></div>)}

                {SelectedUsers && SelectedUsers.Organization && SelectedUsers.Organization.length > 0 &&
                    SelectedUsers.Organization[0].BCardImages && SelectedUsers.Organization[0].BCardImages.length > 0 && (
                        <div id="bImages" className="row business-card-width" style={{ backgroundImage: ('url(' + BusinessCard + ')'), marginTop: "20px" }}>
                            <div style={{ width: "100%", textAlign: "center", }}>
                                <div className="align-center" style={{ width: "100%" }}><h3><u>Services</u></h3></div>
                                <div>
                                    {SelectedUsers.Organization[0].BCardImages.map((images, index) => (
                                        <div key={index} style={{ border: "2px solid #ccc", borderRadius: "10px", padding: "10px", backgroundColor: "white", width: "100%", margin: "2em auto" }}>
                                            <img className="payment-responsive" width="250" height="250"
                                                alt={"Image" + index} src={`${baseURL}bImage/${SelectedUsers.Organization[0]._id}/${images.split('|')[1]}`}></img>
                                        </div>
                                    ))}
                                </div>
                            </div></div>)}

                <div id="enquiry" className="row business-card-width" style={{ backgroundColor: "white", marginTop: "20px" }}>
                    <div style={{ width: "100%", textAlign: "center", }}>
                        <div className="row">
                            <div className="col-md-12 col-sm-12 business-card-enquiry-title">
                                <h5 className="align-center" style={{ fontWeight: "500" }}>Enquiry Form</h5>
                            </div>
                            <div className="col-md-12 col-12" style={{ marginTop: "10px" }}>
                                <div className="text-field">
                                    <input placeholder="" name="Name"
                                        onChange={(e) => onTextChange(e)}
                                        type="text"></input>
                                    <span>Full Name<span className="mandatoryStar">*</span></span>
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="text-field">
                                    <input placeholder="" name="Phone"
                                        onChange={(e) => onTextChange(e)}
                                        type="text"></input>
                                    <span>Phone Number<span className="mandatoryStar">*</span></span>
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="text-field">
                                    <input placeholder="" name="Email"
                                        onChange={(e) => onTextChange(e)}
                                        type="text"></input>
                                    <span>Email ID<span className="mandatoryStar">*</span></span>
                                </div>
                            </div>
                            <div className="col-md-12 col-12">
                                <div className="text-field">
                                    <textarea placeholder="" name="Message" rows="2"
                                        onChange={(e) => onTextChange(e)}
                                        type="text"></textarea>
                                    <span>Message<span className="mandatoryStar">*</span></span>
                                </div>
                            </div>
                            <div className="col-md-12 col-12">
                                <span className="btnStyleWithoutFill" style={{ fontSize: "22px" }}>Send</span>
                            </div>
                        </div>
                    </div></div>
                <div style={{ marginBottom: "80px", marginTop: "5px" }}>
                    <p className="copyright" style={{ color: "#364ed7" }}>© Movers Federation of India {process.env.REACT_APP_DEPLOY_YEAR}</p>
                </div>
            </div>)}
            {(SelectedUsers._id === null || SelectedUsers._id === undefined) && NoData && (
                <div className="align-center" style={{ width: "100%", fontSize: "26px" }}>
                    <div style={{ backgroundColor: "white", padding: "1em" }}>
                        <img className="logo" width="auto" height="60" alt="Welcome Icon" src={WelcomeIcon}></img>
                    </div>
                    <div className="no-business-card">
                        <h1>Business card not available</h1>
                        <div style={{ fontSize: "16px" }}>
                            <div><h5>Please contact administrator at</h5></div>
                            <a style={{ padding: "0 1em", margin: "0 1em" }} className="business-card-support" href="tel:+917090678678">+917090678678</a>
                        </div>
                        <div style={{ fontSize: "16px", marginTop: "1em" }}>
                            <div><h5>You can also mail us at</h5></div>
                            <a style={{ padding: "0 1em", margin: "0 1em" }} className="business-card-support"
                                data-tip="Contact MFI Team." rel="noopener noreferrer" href="mailto:ms@moversfederation.org">MSTeam MFI</a>
                        </div>

                    </div>
                    <div style={{ backgroundColor: "white" }}>
                        <p className="copyright" style={{ color: "#364ed7" }}>© Movers Federation of India {process.env.REACT_APP_DEPLOY_YEAR}</p>
                    </div>
                </div>
            )}
        </div>


    );
};

export default EBusinessCard;